"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootSelectCustom: {
    position: 'relative',
    alignItems: 'center',
    boxSizing: 'border-box',
    border: "1px solid ".concat(_theme.default.palette.grayScale.middleLight),
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    '& > svg': {
      position: 'absolute',
      marginLeft: 20,
      [_theme.default.breakpoints.down('lg')]: {
        marginLeft: 10
      }
    },
    '& .MuiOutlinedInput-root': {
      overflow: 'hidden'
    },
    '& .MuiSelect-select': {
      paddingTop: '15px',
      paddingBottom: '14px'
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: _theme.default.palette.white
    },
    '& .MuiInputBase-root': {
      width: '100%',
      border: 0
    },
    '& fieldset': {
      border: 0
    }
  },
  legend: {
    fontFamily: _theme.default.typography.proxima.regular,
    fontSize: _theme.default.typography.pxToRem('14'),
    lineHeight: _theme.default.typography.pxToRem('17'),
    paddingBottom: 9,
    color: "".concat(_theme.default.palette.grayScale.lowMiddleLight, " !important")
  },
  // Menu props
  listBoxWithIcon: {
    height: 252,
    marginTop: '-3px',
    marginBottom: 0,
    boxSizing: 'border-box',
    fontFamily: _theme.default.typography.proxima.regular,
    '& li': {
      paddingLeft: 54,
      color: _theme.default.palette.grayScale.dark,
      fontFamily: _theme.default.typography.proxima.regular,
      height: 50
    },
    '& li:first-child': {
      display: 'none'
    },
    [_theme.default.breakpoints.down('md')]: {
      '& li': {
        paddingLeft: 44
      }
    }
  },
  listBoxWithOutIcon: {
    marginTop: '-3px',
    marginBottom: 0,
    boxSizing: 'border-box',
    fontFamily: _theme.default.typography.proxima.regular,
    '& li': {
      color: _theme.default.palette.grayScale.dark,
      fontFamily: _theme.default.typography.proxima.regular,
      height: 50
    },
    '& li:first-child': {
      display: 'none'
    }
  },
  // select props
  select: {
    backgroundColor: 'transparent !important',
    paddingLeft: 54,
    fontFamily: _theme.default.typography.proxima.regular,
    color: 'inherit',
    [_theme.default.breakpoints.down('lg')]: {
      paddingLeft: 44
    }
  }
});
var _default = exports.default = useStyles;